
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1696838151087",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "13326",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "500",
    "height": "500"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M327.5776 0h314.2656c4.4544 0 6.656 1.9968 6.656 5.9904v97.28c0 3.9424-2.2016 5.9392-6.656 5.9392H327.5776c-4.5056 0-6.7072-1.9968-6.7072-5.9392v-97.28c0-3.9936 2.2016-5.9904 6.656-5.9904z",
        "p-id": "13327"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M399.36 968.704H347.136a7.9872 7.9872 0 0 1-5.7344-2.3552 8.192 8.192 0 0 1-2.3552-5.7856v-98.304a8.192 8.192 0 0 1 0.6144-3.2256l88.4224-163.3792a8.0896 8.0896 0 0 1 7.424-4.9152h93.952a7.9872 7.9872 0 0 0 5.6832-2.3552 8.192 8.192 0 0 0 2.3552-5.7856v-93.0304c0-4.4032 3.584-7.9872 7.936-7.936h321.536V135.168a25.7536 25.7536 0 0 0-25.344-26.0096h-136.6528v64.1024c0 14.336-11.264 25.9072-25.344 26.0096H289.792a25.7536 25.7536 0 0 1-25.3952-26.0096V109.2096H127.7952A25.7536 25.7536 0 0 0 102.4 135.2192v821.8112c0 14.2848 11.3152 25.9072 25.3952 26.0096h287.1296c-4.0448-8.704-11.3664-14.336-15.5648-14.336zM244.0704 359.1168c0-6.656 5.2224-12.032 11.776-12.0832h457.6256c6.5024 0.0512 11.776 5.4272 11.776 12.0832V423.424c0 6.656-5.2736 12.032-11.776 12.0832H255.8976a11.9808 11.9808 0 0 1-11.776-12.0832l-0.0512-64.3584z m0 270.848v-64.4096c0-6.656 5.2224-12.032 11.776-12.0832h222.976c6.5024 0.0512 11.776 5.4784 11.776 12.0832v64.4096c0 6.6048-5.2736 11.9808-11.776 12.032H255.8976a11.9808 11.9808 0 0 1-11.776-12.032h-0.0512z",
        "p-id": "13328"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M446.6688 702.1056l-70.6048 133.376a6.5536 6.5536 0 0 0-0.6144 2.7648v65.6384a7.1168 7.1168 0 0 0 7.2192 6.9632h60.0064a7.168 7.168 0 0 1 7.168 6.3488c3.3792 36.864 35.84 65.8432 75.264 65.8432 39.4752 0 71.8848-28.9792 75.264-65.8432a7.168 7.168 0 0 1 7.168-6.3488h97.0752a7.168 7.168 0 0 1 7.2192 6.3488c3.328 36.864 35.7376 65.8432 75.264 65.8432 39.424 0 71.8336-28.9792 75.2128-65.8432a7.168 7.168 0 0 1 7.168-6.3488h44.9024a7.1168 7.1168 0 0 0 7.2192-6.9632V607.744a7.1168 7.1168 0 0 0-7.168-6.9632h-341.6064a6.9632 6.9632 0 0 0-7.168 6.8096v83.456a7.1168 7.1168 0 0 1-7.168 6.912H453.376a7.3216 7.3216 0 0 0-6.7072 4.1984z m302.1312 209.92c-0.6656-20.8384 17.152-37.888 38.9632-37.2736 19.7632 0.6144 35.84 16.0256 36.5056 34.9184 0.7168 20.8384-17.152 37.888-38.9632 37.2736-19.7632-0.6144-35.84-16.0256-36.5056-34.9184z m-261.4272 0c-0.6656-20.8384 17.152-37.888 39.0144-37.2736 19.7632 0.6144 35.84 16.0256 36.4544 34.9184 0.7168 20.8384-17.1008 37.888-38.912 37.2736-19.8144-0.6144-35.8912-16.0256-36.5568-34.9184z m71.2704-75.264H434.8928a6.912 6.912 0 0 1-5.9904-2.9184 7.0144 7.0144 0 0 1-0.6656-6.7072l46.3872-84.8384a7.168 7.168 0 0 1 6.656-4.1984h77.4144a7.1168 7.1168 0 0 1 7.168 6.9632v84.7872a7.1168 7.1168 0 0 1-7.168 6.9632z",
        "p-id": "13329"
      }
    }
  ]
})
    }
  